const checkIsFetchingAnyParam = params =>
  Object.values(params).some(({ isFetchingParamData }) => isFetchingParamData);

export default checkIsFetchingAnyParam;
